import DistributionModal from '@/components/submitOrder/distributionModal.vue'
import InvoiceModal from '@/components/submitOrder/invoiceModal.vue'
import moment from 'moment'
import axios from 'axios'
import { Dialog } from 'vant'

// 提交订单页
export const submitOrder = {
  components: {
    InvoiceModal,
    DistributionModal
  },
  data() {
    return {
      //配送方式弹窗
      distributionInfo: {
        show: false,
        info: {}
      },
      //发票信息弹窗
      invoiceModalInfo: {
        show: false,
        info: {}
      },
      //用户信息
      userInfo: {
        username: '',
        mobileno: '',
        address: ''
      },
      //总计
      total: {
        count: 0,
        price: 0,
        priceBak: 0,
        deliveryPrice: 0,
        deliveryPriceBak: 0
      },
      source: null,
      submitLoading: false, //提交中
      orderId: this.$route.query.orderId
    }
  },
  watch: {
    // 零售 购买日期列表
    '$store.state.newsKiosk.dateList': {
      deep: true,
      handler(newValue) {
        // 每次操作都要把值存进去，留给返回订阅订阅页面用
        this.$store.dispatch('newsKiosk/updateActionDateList', newValue)
        // 共x件
        let count =
          newValue.length > 1
            ? newValue.reduce((total, item) => {
                return (total.number ? total.number : total) + item.number
              })
            : newValue[0].number
        // 快递费
        let deliveryPrice = count > this.mainOrder.countStep ? this.mainOrder.freightMore : this.mainOrder.freight
        // 总价
        let price =
          newValue.length > 1
            ? newValue.reduce((total, item) => {
                return ((total.price ? total.price * total.number : total) * 100 + item.price * item.number * 100) / 100
              })
            : Number.parseFloat(newValue[0].price) * newValue[0].number
        price = ((price * 100 + (this.delivertype === 2 ? 0 : deliveryPrice) * 100) / 100).toFixed(2)
        Object.assign(this.total, {
          count,
          price,
          priceBak: price,
          deliveryPrice: this.delivertype === 2 ? 0 : deliveryPrice,
          deliveryPriceBak: deliveryPrice
        })
      }
    },
    // 非零售 购买数量
    goodsNumber(newValue) {
      let { price: priceParams } = this.$route.query
      // 共x件
      let count = newValue
      // 总价
      let price = (newValue * Number.parseFloat(priceParams)).toFixed(2)

      Object.assign(this.total, {
        count,
        price,
        priceBak: price
      })
    }
  },
  computed: {
    getDelivertype() {
      let res = ''
      switch (this.delivertype) {
        case 1:
          res = '中国邮政快递包裹'
          break
        case 2:
          res = '自取'
          break
        case 0:
          res = '邮政投递'
          break
        case 3:
          res = '邮发'
          break
      }
      return res
    },
    getInvoice() {
      let res = ''
      switch (this.papertype) {
        case 0:
          res = '不开发票'
          break
        case 1:
          res = '开发票'
          break
        case 2:
          res = '开收据'
          break
      }
      return res
    }
  },
  methods: {
    moment,
    /**
     * todo 取消订阅
     */
    cancelOrderRetailGoods() {
      let { orderId } = this.$route.query
      let params = { orderId }
      return new Promise((resolve, reject) => {
        this.$api.userCentered.cancelOrderRetailGoods(params).then((res) => {
          let { status } = res
          if (status) {
            // 同时清空订阅后的订单
            window.sessionStorage.removeItem('orderId')
            // 取消订阅后跳转到订阅商品页面，把商品信息带过去
            this.$router.replace({ name: 'SubscribeDetail', query: { typeId: this.typeId, id: this.goodsId } })
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    /**
     * todo 校验报卡id
     */
    valiDateCardId(value, rule) {
      if (!value) {
        this.total.price = this.total.priceBak
        return false
      }
      let params = {
        goodsid: this.goodsId,
        cardId: value
      }
      return new Promise((reslove, reject) => {
        this.$api.goodList.checkCardId(params).then((res) => {
          let { status, message } = res
          if (status) {
            this.total.price = 0
          } else {
            this.total.price = this.total.priceBak
          }
          rule.message = message
          reslove(status, rule)
        })
      })
    },
    /**
     * todo 查询订阅生成的订单信息
     */
    getRetailGoodsOrderInfo() {
      let params = { orderId: this.$route.query.orderId }

      return new Promise((resolve, reject) => {
        this.$api.goodList.getRetailGoodsOrderInfo(params).then((res) => {
          let { result } = res
          if (result && Object.getOwnPropertyNames(result).length) {
            this.$store.dispatch('newsKiosk/updateActionOrderInfo', result)
            resolve(result)
          } else {
            reject()
          }
        })
      })
    },
    /**
     * todo 自定义敏感词校验规则
     */
    validateInput(value, rule) {
      // if (this.source) {
      //   this.source.cancel('取消查询！')
      // }
      if (!value) {
        return true
      }

      return new Promise((resolve, reject) => {
        let params = {
          contentStr: value
        }
        let cancelToken = axios.CancelToken
        this.source = cancelToken.source()
        this.$api.userComplaints
          .checkSensitiveWords(params, { cancelToken: this.source.token })
          .then((res) => {
            let { count, result } = res
            if (count > 0) {
              resolve(true)
            } else {
              rule.message = result
              resolve(false, rule)
            }
          })
          .catch((err) => {
            rule.message = err.message
            resolve(false, rule)
          })
      })
    },
    /**
     * todo 打开配送方式弹窗
     */
    chooseDistributionMode() {
      // 如果是报卡、或者是全年的商品 禁止使用
      if (this.typeId === 1 || this.goodsId === 314) {
        return
      }
      this.distributionInfo = {
        show: true,
        type: this.delivertype,
        info: {
          type: this.delivertype
        }
      }
    },
    /**
     * todo 选择后的配送方式结果
     */
    getDisstributionInfo(type) {
      this.delivertype = type
      this.total.deliveryPrice = type === 2 ? 0 : this.total.deliveryPriceBak
      this.total.price = type === 2 ? ((this.total.priceBak * 100 - this.total.deliveryPriceBak * 100) / 100).toFixed(2) : this.total.priceBak
    },
    /**
     * todo 删除日期
     */
    deleDate({ subOrderId }) {
      if (this.$store.state.newsKiosk.dateList.length < 2) {
        this.$toast('商品数量不能为空！')
        return
      }
      this.$store.dispatch(
        'newsKiosk/updateActionDateList',
        this.$store.state.newsKiosk.dateList.filter((item) => item.subOrderId !== subOrderId)
      )
    },
    /**
     * todo 打开发票信息弹窗
     */
    openInvoiceModal() {
      this.invoiceModalInfo = {
        show: true
      }
    },
    /**
     * todo 是否关注
     */
    checkUserSubscribe() {
      this.$api.user.checkUserSubscribe().then((res) => {
        let { count, result } = res
        if (count > 0) {
          this.submitValidateOrder()
        } else {
          Dialog.alert({
            message: result
          }).then(() => {
            // on close
          })
        }
      })
    },
    /**
     * todo 提交订单 验证
     */
    submitValidateOrder() {
      let datelist = this.$store.state.newsKiosk.dateList
      // 特殊类商品需求增加提交提示
      if (this.typeId !== 4 && this.typeId !== 1) {
        Dialog.confirm({
          title: '提示',
          message: '商品需经确认后再付款',
          confirmButtonText: '继续提交'
        })
          .then(() => {
            // on confirm
            this.$refs.form.submit()
          })
          .catch(() => {
            // on cancel
          })
        // 公众号-提交订单页面-订单包含预售商品时，点击提交订单的时候要提醒，”订单中包含预售商品，预售商品将于上架当日发货（确认+取消按钮）“（新增需求）
      } else if (this.typeId === 4 && datelist.some((item) => moment(item.date).valueOf() > moment().valueOf())) {
        Dialog.confirm({
          title: '提示',
          message: '订单中包含预售商品，预售商品将于上架当日发货',
          confirmButtonText: '继续提交'
        })
          .then(() => {
            // on confirm
            this.$refs.form.submit()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        this.$refs.form.submit()
      }
    },
    /**
     * todo 提交订单
     */
    submitOrder() {
      let { requirement, cardid } = this.formData
      let { orderId } = this.$route.query
      let params = {}

      // 零售
      if (this.typeId == 4) {
        if (!this.$store.state.newsKiosk.dateList.length) {
          this.$toast('请选择订阅日期！')
          return
        }
        if (this.mainOrder.mobileNo.split('').length !== 11) {
          Dialog.alert({ message: '修改失败，请输入正确的手机号' })
          return
        }
        params = {
          orderInfo: {
            id: orderId,
            delivertype: this.getDelivertype,
            papertype: this.papertype,
            requirement,
            ...this.papertypeInfo
          },
          subOrderInfos: this.$store.state.newsKiosk.dateList.map((item) => {
            let { subOrderId: id, number: goodsnumber, date: saledate } = item
            return { id, goodsnumber, saledate }
          }),
          totalPrice: this.total.price
        }
        let total = params.subOrderInfos.reduce((prev, cur) => {
          return cur.goodsnumber + prev
        }, 0)
        if (total > 10) {
          this.$toast('单笔订单最大购买数量为10份！')
          return
        }
        this.submitLoading = true
        this.$api.goodList.submitRetailGoodsOrder(params).then((res) => {
          this.submitLoading = false
          let { status, result } = res
          if (status && result && JSON.stringify(result) !== '{}') {
            this.orderId = result.orderId
            this.weixinJSBridge(result.weixinPay)
          }
        })
        // 非零售
      } else {
        // 获取 userInfo 包括 用户信息 手机号 地址相关
        // this.getWxConfig().then((res) => {
        let { userName: username, phone: mobileno, postalCode, provinceName, cityName, countryName, address, nationalCode } = JSON.parse(window.localStorage.getItem('addressInfo')) || {}
        this.userInfo = { username, mobileno, postalCode, provinceName, cityName, countryName, address, nationalCode }

        params = {
          goodsid: this.goodsId,
          goodsnumber: this.goodsNumber,
          requirement,
          delivertype: this.getDelivertype,
          totalprice: this.total.price,
          papertype: this.papertype,
          ...this.userInfo
        }
        // 选择开发票的时候，才带上发票信息相关字段
        if (this.papertype === 1) {
          params = {
            ...params,
            ...this.papertypeInfo
          }
        }
        // 报卡
        if (this.typeId === 1) {
          params = {
            ...params,
            requirement,
            cardid,
            papertype: 0, //报卡类型，发票为0，不开发票
            goodsnumber: 1
          }
        }
        this.$api.goodList.submitNoRetailGoodsOrder(params).then((res) => {
          let { result } = res
          if (result && JSON.stringify(result) !== '{}') {
            this.$router.push({ path: '/reception' })
            window.sessionStorage.removeItem('active')
          }
        })
        // })
      }
    },
    /**
     * todo 拉取微信支付
     */
    weixinJSBridge(payInfo) {
      let _this = this
      try {
        let { appId, timeStamp, nonceStr, pay_package, paysign } = payInfo
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId, //公众号名称，由商户传入
            timeStamp: timeStamp + '', //时间戳
            nonceStr, //随机串
            package: pay_package, ////扩展包
            signType: 'MD5', //微信签名方式:1.sha1
            paySign: paysign
          },
          (res) => {
            // 清空订阅订单
            window.sessionStorage.removeItem('orderId')
            // 支付成功
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
              _this.validatorPayResult()
            } else {
              // 支付失败，回到待付款
              _this.$router.push({ path: '/reception' })
            }
          }
        )
      } catch (error) {
        alert(error)
      }
    },
    /**
     * todo 支付完成后拉取支付确认接口
     */
    validatorPayResult() {
      let params = {
        tno: this.orderId
      }
      this.$api.user.validatorPayResult(params).then((res) => {
        let { status, message } = res
        if (status) {
          this.$router.push({ path: '/reception' })
          window.sessionStorage.removeItem('active')
        } else {
          this.$toast(message)
        }
      })
    },
    /**
     * todo 拉取微信配置信息接口
     * @param {url: 当前全部地址，包括参数}
     */
    getWxConfig() {
      // 获取 userInfo 包括 用户信息 手机号 地址相关
      return new Promise((resolve, reject) => {
        // 配置微信
        const wxApi = (data) => {
          window.wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['checkJsApi', 'openAddress', 'editAddress']
          })
          window.wx.ready(function () {
            window.wx.openAddress({
              success: function (res) {
                // 提交
                resolve(res)
              },
              cancel(errMsg) {
                reject(errMsg)
              }
            })
          })

          window.wx.error(function (res) {
            reject(res.errMsg)
          })
        }

        // 拉取微信配置信息
        this.$api.user.getWxConfig({ url: window.location.href }).then((res) => {
          let { result } = res
          if (JSON.stringify(result) !== '{}') {
            wxApi(result)
          }
        })
      })
    },
    /**
     * todo 获取发票信息选择后的结果
     */
    getInvoiceInfo(type, info) {
      this.papertype = type
      this.papertypeInfo = info
    },
    /**
     * todo 选择库存小于1的是，删除
     */
    changeNumber({ number, subOrderId }) {
      if (number < 1) {
        if (this.$store.state.newsKiosk.dateList.length < 2) {
          this.$toast('商品数量不能为空！')
          return
        }
        this.$nextTick(() => {
          this.$store.dispatch(
            'newsKiosk/updateActionDateList',
            this.$store.state.newsKiosk.dateList.filter((item) => item.subOrderId !== subOrderId)
          )
        })
      }
    }
  }
}
